var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-object-card",
      attrs: { "data-type": `Object`, "data-name": _vm.title },
    },
    [
      _c("a", { attrs: { href: _vm.url } }, [
        _c("span", { staticClass: "t-visually-hidden" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _vm._v(" "),
      _vm.finalGalleryImages.length > 0
        ? _c("v-gallery", {
            attrs: {
              images: _vm.transformedGalleryImages,
              "step-length": 1,
              "premise-types": _vm.normalizedPremiseTypes,
              "icon-label": _vm.iconLabel,
              title: _vm.title,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "c-object-card__content" }, [
        _c("p", { staticClass: "c-object-card__text" }, [
          _vm._v(_vm._s(_vm.address)),
        ]),
        _vm._v(" "),
        _vm.title
          ? _c("p", { staticClass: "c-object-card__byline" }, [
              _vm._v(_vm._s(_vm.title)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.sizeFrom || _vm.sizeTo || _vm.workplaceDisplay || _vm.priceDisplay
          ? _c("div", { staticClass: "c-object-card__info-boxes" }, [
              _vm.sizeFrom || _vm.sizeTo
                ? _c("div", { staticClass: "c-object-card__info-box" }, [
                    _c("i", {
                      staticClass:
                        "fa-regular fa-ruler c-object-card__info-box-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "c-object-card__info-box-text" },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.fixedSize) + "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.workplaceDisplay
                ? _c("div", { staticClass: "c-object-card__info-box" }, [
                    _c("i", {
                      staticClass:
                        "fa-regular fa-users c-object-card__info-box-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "c-object-card__info-box-text" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.workplaceDisplay) +
                            " st\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.priceDisplay
                ? _c("div", { staticClass: "c-object-card__info-box" }, [
                    _c("i", {
                      staticClass:
                        "fa-regular fa-building c-object-card__info-box-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "c-object-card__info-box-text" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.priceDisplay) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }